import { AlertBanner, AlertBannerButton, AlertBannerText } from "monday-ui-react-core";
import { useCallback } from "react";

interface Props {
  text: string;
  isCloseHidden?: boolean;
  onClose?: VoidFunction;
}

export function BuyNowBanner({ text, isCloseHidden = true, onClose }: Props) {
  const onBuyNowClick = useCallback(() => {
    window.open("https://apps.appf.re/kJ9sNv", "blank", "noreferrer,noopener");
  }, []);

  const onAlertBannerClose = useCallback(() => {
    onClose?.();
  }, [onClose]);

  return (
    <AlertBanner isCloseHidden={isCloseHidden} onClose={onAlertBannerClose}>
      <>
        <AlertBannerText data-testid="license-banner-message" text={text} />
        <AlertBannerText text=" " />
        <AlertBannerButton onClick={onBuyNowClick}>Buy now</AlertBannerButton>
      </>
    </AlertBanner>
  );
}
